<template>
  <v-container grid-list-md pt-4 mt-5 class='subscription subscription-br text-center'>
    <div v-if="this.selectedCarrier === 'confirm-sms-vivo'">
      <v-layout row wrap>
        <h2>Enviamos para o seu celular uma mensagem com o resumo do seu pedido.</h2>

        <h4 class='mt-5'>
          Basta responder
          <strong>SIM</strong> a essa mensagem (do seu celular mesmo) para confirmar e pronto!
        </h4>
      </v-layout>
    </div>

    <div v-else>
      <v-layout row wrap>
        <v-flex mb-4>
          <h1>SELECIONE SUA OPERADORA</h1>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex xs6>
          <button
            @click="swapCarrier('vivo')"
            :class="{ active : this.selectedCarrier === 'vivo', 'carrier-img':true }"
          >
            <img src='@/assets/img/logo-vivo.png' />
          </button>
        </v-flex>

        <v-flex xs6>
          <button
            carrier-img
            @click="swapCarrier('oi')"
            :class="{ active : this.selectedCarrier === 'oi' , 'carrier-img':true }"
          >
            <img src='@/assets/img/logo-oi.png' />
          </button>
        </v-flex>

        <v-flex xs6>
          <!--
          <button
            carrier-img
            @click="swapCarrier('claro')"
            :class="{ active : this.selectedCarrier === 'claro' , 'carrier-img':true }"            
          >
            <img src="@/assets/img/logo-claro.png" />
          </button>
          -->
          <!-- <a
            carrier-img
            href="http://consent.clarosgvas.mobicare.com.br/ZED-SUPER-COMICS-SEMANAL-D3-FUTURA"
            target="_blank"
            :class="{ active : this.selectedCarrier === 'claro' , 'carrier-img':true }"
          >
            <img src="@/assets/img/logo-claro.png" />
          </a> -->
          <button
            carrier-img
            @click="swapCarrier('claro')"
            :class="{ active : this.selectedCarrier === 'claro' , 'carrier-img':true }"
          >
            <img src='@/assets/img/logo-claro.png' />
          </button>
        </v-flex>
      </v-layout>

      <v-layout row wrap>
        <v-flex sm6 offset-sm3 xs12 mt-5 class='carrier-tip' v-if="this.selectedCarrier === 'oi'">
          <span>Cliente Oi: Envie "QUERO" para <strong>77125</strong> para mais informações.</span>
        </v-flex>

        <v-flex sm6 offset-sm3 xs12 mt-5 class='carrier-tip' v-if="this.selectedCarrier === 'vivo'">
          <span>Cliente Vivo: Envie "HQ" para <strong>77125</strong> para mais informações.</span>
        </v-flex>
      </v-layout>

      <v-flex sm6 offset-sm3 xs12 mt-5 class='carrier-tip' v-if="this.selectedCarrier === 'claro'">
        <span>Cliente Claro: Envie "ASSINAR" para <strong>77125</strong> para mais informações.</span>
      </v-flex>

    </div>
  </v-container>
</template>

<script>

export default {
  name: 'subscriptionBR',
  metaInfo() {
    return {
      title: 'Assinar E-Komics'
    };
  },
  created() {
    if (this.activeSubscription) {
      this.$router.push('/');
    }
  },
  data() {
    return {
      selectedCarrier: ''
    };
  },
  computed: {
    profile() {
      return this.$store.getters.profile;
    },
    activeSubscription: function() {
      return this.$store.getters['activeSubscription'];
    },
    phoneNumber() {
      return this.profile.msisdn.substring(2);
    }
  },
  methods: {
    swapCarrier: function(carrier) {
      this.selectedCarrier = carrier;
    }
  }
};
</script>

<style lang='scss'>
@import '../../assets/css/_variables';

.subscription-br {
  .carrier-tip {
    margin-top: 100px;
    padding: 50px 20px 50px !important;
    background: #F0F0F0;
    display: block;
  }
  
  .carrier-img {
    display: block;
    padding: 20px;
    width: 100%;
    transition: all 0.3s ease;
    height: 100px;
    // border-radius: 5px;
    border-bottom: solid 2px transparent;
    
    &:hover {
      background-color: #F0F0F0;
    }
    
    &:focus {
      outline: none;
    }
  }
  
  .active {
    border-bottom: solid 2px $primary;
    background-color: rgba(black, 0.02);
  }
  
  img {
    max-width: 100%;
  }
  
  .claro-iframe {
    border: 0;
    width: 100%;
    height: 800px;
    overflow: hidden;
  }
}
</style>
